import { render, staticRenderFns } from "./loanBalance.vue?vue&type=template&id=816a480c&scoped=true&"
import script from "./loanBalance.vue?vue&type=script&lang=js&"
export * from "./loanBalance.vue?vue&type=script&lang=js&"
import style0 from "./loanBalance.vue?vue&type=style&index=0&id=816a480c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816a480c",
  null
  
)

export default component.exports